// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Includes inherited overrides from: core -> theme-preferred -> dietz-property-group-preferred -> woodside-place-apartments
// Generated: 2026-09-02T15:53:03.135Z
// Counts: 4 design, 64 content, 9 slot group, 5 collection binding, 9 section, 1 style

export const designOverrides = {
  "design._site.font.heading": {
    "cssVariable": "--vibe-font-heading",
    "overrideType": "VALUE",
    "value": "'Montserrat', sans-serif",
    "mappedField": null
  },
  "design._site.color.accent": {
    "cssVariable": "--vibe-color-accent",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_color_3"
  },
  "design._site.color.hyperlink": {
    "cssVariable": "--vibe-color-hyperlink",
    "overrideType": "FIELD_MAPPING",
    "value": null,
    "mappedField": "property_primary_color"
  },
  "design._site.color.linkUnderline": {
    "cssVariable": "--vibe-color-link-underline",
    "overrideType": "VALUE",
    "value": "underline",
    "mappedField": null
  }
};

export const contentOverrides = {
  "accessibilityhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Accessibility</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Amenities</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.apartmentHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Apartment Features</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.communityHeading": {
    "overrideType": "VALUE",
    "customValue": "<h2>Community Amenities</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "amenitieslist.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "applynowhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Apply Now</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form_title": {
    "overrideType": "VALUE",
    "customValue": "Test",
    "generatedValue": null,
    "mappedField": null
  },
  "contactform.form.form_header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "contacthero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Contact Us</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "ctasection.card1.description": {
    "overrideType": "VALUE",
    "customValue": "<p>Choose from our spacious <span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> bedroom floor plans.</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "fees.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Floor Plans</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "floorplanslist.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Make Yourself at Home in Gahanna</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.address": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "footer.copyright": {
    "overrideType": "VALUE",
    "customValue": "© 2026 All Rights Reserved.",
    "generatedValue": null,
    "mappedField": null
  },
  "footer.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "gallery.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "gallery.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "google-tag-manager.container_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_google_gtm_id"
  },
  "hero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2><span data-type=\"field-token\" data-field=\"property_bedrooms_range\"></span> Bedroom Apartments for Rent in <span data-type=\"field-token\" data-field=\"property_address_city\"></span>, <span data-type=\"field-token\" data-field=\"property_address_state\"></span></h2><h2></h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "hero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Welcome to <span data-type=\"field-token\" data-field=\"property_name\"></span></h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.subtitle": {
    "overrideType": "VALUE",
    "customValue": "<h2>Enjoy luxury living with a pool at Liberty Pointe in Oklahoma City. Discover the perfect blend of comfort and luxury in our beautiful community.</h2>",
    "generatedValue": null,
    "mappedField": null
  },
  "featuring/luxury-apartments-pool-oklahoma-city::hyperlocalhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Luxury Apartments with Pool in OKC</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "interactivemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Interactive Map</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "json-ld-schema.override_phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "neighborhoodcallout.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Discover a convenient location at Woodside Place, offering <strong>apartments in Gahanna, OH</strong> near the shopping, dining, recreation, and employment destinations that make the area easy to explore.&nbsp;</span></p><p><span style=\"font-size: 10pt;\">Enjoy convenient access to Easton Town Center, Creekside Park &amp; Arboretum, Blendon Woods Metro Park, and John Glenn Columbus International Airport, with Downtown Columbus also within reach.&nbsp;</span></p><p><span style=\"font-size: 10pt;\">Whether you're heading out for dinner, shopping, outdoor recreation, or your daily commute, Woodside Place puts you close to destinations throughout Gahanna and the greater Columbus area.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodcallout.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Gahanna Townhomes Near Columbus, OH</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Neighborhood</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhoodmap.category_order": {
    "overrideType": "VALUE",
    "customValue": "Shopping & Retail, Education, Entertainment, Health and Wellness, Nature & Outdoor Attractions, Transportation & Transit, Major Employers & Offices, Restaurants",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "pageblurb.scheduler.header_text": {
    "overrideType": "VALUE",
    "customValue": "Schedule",
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.subtitle": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "pagehero.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "petpolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Pet Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "privacypolicyhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Privacy Policy</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertycontactinfo.phone": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_call_tracking_phone"
  },
  "propertyoverview.pre_title": {
    "overrideType": "VALUE",
    "customValue": "<p>Your Search Ends Here</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.title": {
    "overrideType": "VALUE",
    "customValue": "<p>Woodside Place Apartments in Gahanna, OH</p>",
    "generatedValue": null,
    "mappedField": null
  },
  "rentgrata-widget.property_id": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_rentgrata_token"
  },
  "residentaccesshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Resident Access</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewscallout.title": {
    "overrideType": "VALUE",
    "customValue": "<h3>What Residents Say About <span data-type=\"field-token\" data-field=\"property_name\"></span></h3>",
    "generatedValue": null,
    "mappedField": null
  },
  "reviewshero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Reviews</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "schedule-tour-blurb.scheduler_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-tour-scheduler",
    "generatedValue": null,
    "mappedField": null
  },
  "scheduleatourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Schedule A Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "sitemaphero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Sitemap</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "thankyouhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Thank You</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.subtitle": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour.title": {
    "overrideType": "VALUE",
    "customValue": null,
    "generatedValue": null,
    "mappedField": null
  },
  "virtualtourhero.title": {
    "overrideType": "VALUE",
    "customValue": "<h1>Virtual Tour</h1>",
    "generatedValue": null,
    "mappedField": null
  },
  "_head.favicon_url": {
    "overrideType": "VALUE",
    "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=55/company/5767906449162458/019dffdc-8ac5-716c-b71f-1f453648e537.webp",
    "generatedValue": null,
    "mappedField": null
  },
  "adtaxi-tracking.profile": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_adtaxi_domain"
  },
  "audioeye-widget.cta_color": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "property_primary_color"
  },
  "audioeye-widget.cta_location": {
    "overrideType": "VALUE",
    "customValue": "left-lower",
    "generatedValue": null,
    "mappedField": null
  },
  "knock-chatbot.api_token": {
    "overrideType": "FIELD_MAPPING",
    "customValue": null,
    "generatedValue": null,
    "mappedField": "custom_knock_company_token"
  },
  "scheduleatour.form_block": {
    "overrideType": "VALUE",
    "customValue": "multihub-lead-form",
    "generatedValue": null,
    "mappedField": null
  },
  "contact-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Have questions about availability, </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>floor plans</u></span></a><span style=\"font-size: 10pt;\">, or scheduling a tour? Connect with the leasing team at Woodside Place and learn more about our <strong>apartments for rent in Gahanna, OH. </strong>Whether you're ready to find your next apartment or simply want more information about the community, we're here to help. Contact Woodside Place today to get started and discover your options for apartment living in the Gahanna and Columbus area.&nbsp;</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "floor-plans-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Your ideal home awaits at Woodside Place. Our <strong>Gahanna townhomes near Columbus </strong>are designed to complement your lifestyle. Here, comfortable interiors and practical features complement your everyday routine. Choose from spacious floor plans featuring well-equipped kitchens, generous living areas, ample storage, and private outdoor spaces in select homes. Browse our available floor plans, then take a </span><a class=\"richtext-link\" href=\"/virtual-tour\"><span style=\"font-size: 10pt;\"><u>virtual tour</u></span></a><span style=\"font-size: 10pt;\"> to find an apartment layout and features that fit your needs.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "gallery-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Take a closer look at Woodside Place and picture your space at our <strong>apartments near Columbus, OH</strong>. Browse the photo gallery to explore </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><u>apartment</u></span></a><span style=\"font-size: 10pt;\"> interiors and inviting outdoor spaces throughout the property. Want to view the apartments in more detail? Check out our </span><a class=\"richtext-link\" href=\"/virtual-tour\"><span style=\"font-size: 10pt;\"><u>Virtual Tours</u></span></a><span style=\"font-size: 10pt;\"> and see what makes Woodside Place a distinctive place to call home.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "neighborhood-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Experience a convenient location at Woodside Place, offering <strong>apartments for rent in Gahanna, OH</strong> near shopping, dining, recreation, and major employment destinations.&nbsp;</span></p><p></p><p><span style=\"font-size: 10pt;\">Spend the day shopping and dining at Easton Town Center, approximately 3 miles away, or explore local favorites such as The Barn at Rocky Fork Creek, Local Cantina Gahanna, and Arepazo Tapas Bar &amp; Grill. Outdoor destinations, including Creekside Park &amp; Arboretum and Blendon Woods Metro Park, provide even more ways to enjoy the area.&nbsp;</span></p><p><span style=\"font-size: 10pt;\">Woodside Place is also conveniently located near major employers, including Bread Financial at approximately 1.9 miles, Bath &amp; Body Works distribution operations at about 2 miles, and NetJets Global Headquarters at roughly 3.4 miles. <br><br></span></p><p><span style=\"font-size: 10pt;\">Plus, John Glenn Columbus International Airport is approximately 3.9 miles away, while Downtown Columbus is within about a 15-minute drive, putting even more of the Columbus area within easy reach.</span></p><p></p><p><span style=\"font-size: 10pt;\">Ready to make our community your home? </span><a class=\"richtext-link\" href=\"/contact-us\"><span style=\"font-size: 10pt;\"><u>Contact us</u></span></a><span style=\"font-size: 10pt;\"> today to schedule your tour!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "pet-policy-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">At Woodside Place, life blossoms amidst serene surroundings. Cats and dogs are cherished members of our community, and here, you can enjoy spacious living with your furry companions. Experience the perfect blend of comfort and convenience, where our <strong>pet-friendly </strong></span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><strong><u>apartments</u></strong></span></a><span style=\"font-size: 10pt;\"><strong> in Gahanna</strong> are a welcoming home for all.</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "propertyoverview.description": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Welcome to Woodside Place, where comfort and convenience meet! Our stunning community offers a variety of thoughtfully designed floor plans, including spacious </span><a class=\"richtext-link\" href=\"/floor-plans\"><span style=\"font-size: 10pt;\"><strong><u>one- and two-bedroom apartments and townhomes in Gahanna, OH,</u></strong></span></a><span style=\"font-size: 10pt;\"> to suit your lifestyle.&nbsp;</span></p><p></p><p><span style=\"font-size: 10pt;\">Each </span><a class=\"richtext-link\" href=\"/pet-policy\"><span style=\"font-size: 10pt;\"><u>pet-friendly home</u></span></a><span style=\"font-size: 10pt;\"> offers a variety of features, including private entrances, bay windows, and sliding glass doors leading to your own private patio, perfect for enjoying the fresh air. Our apartments also come equipped with essential features, including a washer and dryer, air conditioning, high-speed internet access, and fully equipped kitchens featuring a refrigerator, range, and dishwasher. With select floor plans offering finished basements and family rooms, you can create the perfect space for relaxation or entertaining.</span></p><p></p><p><span style=\"font-size: 10pt;\">As a resident, you’ll have access to 24-hour emergency service and on-site management, as well as our rental housing discount program. We invite you to browse our available floor plans, take a </span><a class=\"richtext-link\" href=\"/virtual-tour\"><span style=\"font-size: 10pt;\"><u>virtual tour</u></span></a><span style=\"font-size: 10pt;\">, or call us today to schedule an in-person visit.&nbsp;</span></p><p></p><p><span style=\"font-size: 10pt;\">We look forward to welcoming you home to Woodside Place!</span></p>",
    "generatedValue": null,
    "mappedField": null
  },
  "virtual-tour-blurb.text": {
    "overrideType": "VALUE",
    "customValue": "<p><span style=\"font-size: 10pt;\">Explore <strong>Gahanna, OH apartments</strong> from wherever you are with a virtual tour of Woodside Place. Take a closer look at apartment interiors, spacious layouts, and community spaces to get a better feel for what Woodside Place has to offer before scheduling an in-person visit. Start your virtual tour today and discover the features and spaces waiting for you at Woodside Place.</span></p>",
    "generatedValue": null,
    "mappedField": null
  }
};

export const slotGroupOverrides = {
  "amenitieslist.community_photo_5": {
    "sourceIndex": 8,
    "fieldOverrides": null
  },
  "footer.design_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "alt": {
        "type": "VALUE",
        "customValue": "Repli Logo"
      },
      "url": {
        "type": "VALUE",
        "customValue": "https://repli360.com"
      }
    }
  },
  "pagehero.bg_image": {
    "sourceIndex": 6,
    "fieldOverrides": null
  },
  "contactus.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "footer.managed_by_logo": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/company/5767906449162458/019e28a2-7e6e-752b-a7e2-54f21a5cd171.webp"
      }
    }
  },
  "scheduleatour.form.submit_button": {
    "sourceIndex": null,
    "fieldOverrides": {
      "url": {
        "type": "VALUE",
        "customValue": "/thank-you"
      }
    }
  },
  "floorplanslist.card_0": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-7769-7429-82d8-cd3e9884606a.webp"
      }
    }
  },
  "floorplanslist.card_1": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dbb9e-88d5-71e0-aaf6-7aa38e6ac521.webp"
      }
    }
  },
  "floorplanslist.card_viewall": {
    "sourceIndex": null,
    "fieldOverrides": {
      "image": {
        "type": "VALUE",
        "customValue": "https://multihubmedia.com/cdn-cgi/image/format=auto,w=1280/property/6767906449167382/019dc045-7e96-76a3-8944-cd52e40ec9ce.webp"
      }
    }
  }
};

export const collectionBindingOverrides = {
  "amenitieslist.carousel_images": {
    "limit": 1,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "amenitieslist.items": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.gallery_images": {
    "limit": null,
    "hiddenIds": null,
    "orderedIds": null,
    "hiddenIndices": null,
    "ordering": [
      0,
      1,
      2,
      3,
      4,
      5,
      6,
      7,
      8,
      9,
      10,
      11,
      12,
      13,
      14,
      15,
      16,
      17,
      18,
      19,
      20,
      21,
      22,
      23,
      24,
      25,
      26,
      27,
      28,
      29,
      30,
      31,
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61
    ],
    "customItems": null
  },
  "amenitieslist.communityItems": {
    "limit": null,
    "hiddenIds": [
      "ec_3aea658e6e715e4bb1eadde3",
      "ec_d6938d367a27ea5b46d8db41",
      "ec_c5f6bcf4f22c7bb8dc895378",
      "ec_8fb81b4f588da083da21a091"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      2,
      3,
      4,
      5,
      6
    ],
    "ordering": null,
    "customItems": null
  },
  "propertyoverview.community_amenities": {
    "limit": null,
    "hiddenIds": [
      "ec_3aea658e6e715e4bb1eadde3",
      "ec_d6938d367a27ea5b46d8db41",
      "ec_c5f6bcf4f22c7bb8dc895378",
      "ec_8fb81b4f588da083da21a091"
    ],
    "orderedIds": null,
    "hiddenIndices": [
      0,
      1,
      2,
      3,
      4,
      5,
      6
    ],
    "ordering": null,
    "customItems": null
  }
};

export const sectionOverrides = {
  "_global": [
    {
      "sectionId": "google-tag-manager",
      "blockId": "google-tag-manager",
      "position": 0
    },
    {
      "sectionId": "json-ld-schema",
      "blockId": "json-ld-schema",
      "position": 0
    },
    {
      "sectionId": "multihub-lead-capture",
      "blockId": "multihub-lead-capture",
      "position": 0
    },
    {
      "sectionId": "adtaxi-tracking",
      "blockId": "adtaxi-tracking",
      "position": 0
    },
    {
      "sectionId": "audioeye-widget",
      "blockId": "audioeye-widget",
      "position": 0
    },
    {
      "sectionId": "knock-chatbot",
      "blockId": "knock-chatbot",
      "position": 0
    },
    {
      "sectionId": "realpage-calendar",
      "blockId": "realpage-calendar",
      "position": 0,
      "visible": false
    }
  ],
  "apply-now": [
    {
      "sectionId": "realpage-oll",
      "blockId": "realpage-oll",
      "position": 10
    }
  ],
  "interactive-map": [
    {
      "sectionId": "engrain-sitemap",
      "blockId": "engrain-sitemap",
      "position": 8
    }
  ]
};

export const styleOverrides = {
  "hero.subtitle": {
    "properties": {
      "textAlign": "center"
    }
  }
};
